import React, { useState } from 'react'
import styled from 'styled-components'
import 'leaflet/dist/leaflet.css'
import { Map as LeafletMap, TileLayer } from 'react-leaflet'
import { Overlay } from '../Overlay'
import { MapMarker } from './MapMarker'
import { IMapMarkerProps } from './IMapMarkerProps'
import { LatLng } from '../../types/LatLng.types'

const StyledMap = styled.div`
  position: relative;
`

const StyledLeafletMap = styled(LeafletMap)`
  z-index: 1;
  ${({ width, height }) => `
    width: ${width};
    height: ${height};
  `}
`

const StyledOverlay = styled(Overlay)`
  position: absolute;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
`

interface IMapProps {
  className?: string
  center?: LatLng
  zoom?: number
  height?: string
  width?: string
  isShowOverlay?: boolean
  children?: React.ReactNode
  markers?: Array<IMapMarkerProps>
}

const Map: React.FC<IMapProps> = ({
  className,
  center = {
    lat: -37.813629,
    lng: 144.963058,
  },
  zoom = 16,
  children,
  height = '100%',
  width = '100%',
  markers = [],
  isShowOverlay = true,
}) => {
  const [isOpenOverlay, setIsOpenOverlay] = useState(true)
  const position = [center.lat, center.lng]
  return (
    <StyledMap
      className={className}
      onMouseDown={(ev) => ev.stopPropagation()}
      onTouchStart={(ev) => ev.stopPropagation()}
    >
      <StyledLeafletMap
        center={position}
        zoom={zoom}
        width={width}
        height={height}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
        />
        {children}
        {markers.map(({ lng, lat, popupTitle }) => (
          <MapMarker
            key={`${lat}-${lng}`}
            lng={lng}
            lat={lat}
            popupTitle={popupTitle}
          />
        ))}
      </StyledLeafletMap>
      {isShowOverlay && isOpenOverlay && (
        <StyledOverlay onClick={() => setIsOpenOverlay(false)} />
      )}
    </StyledMap>
  )
}

export { Map }
